import React from "react";
import { useHistory } from "react-router-dom";
import algoliasearch from "algoliasearch/lite";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Avatar from "@material-ui/core/Avatar";

import { SearchArea } from "../Utilities/SearchArea";
import { ScoreView } from "../Utilities/ScoreView";
import { Activity } from "../Types/types";

const client = algoliasearch("V7NYNJIM7C", "439a81efb8f918ee5bf3b0380b0f9f28");

export interface Group {
  objectID: string;
  img: string;
  group: string;
  clean_group: string;
  activities: Activity[];
  score: number;
  hogroupage: string;
  word_cloud: string;
}

export const GroupView = () => {
  const [index] = React.useState(client.initIndex("groups"));

  const [currentQuery, setCurrentQuery] = React.useState<string>("");
  const [currentHits, setCurrentHits] = React.useState<Group[]>([]);

  const submitSearch = async () => {
    const searchResults = await index.search(currentQuery);
    setCurrentHits(searchResults.hits as Group[]);
  };

  React.useEffect(() => {
    submitSearch();
  }, []);

  return (
    <Container maxWidth={false}>
      <SearchArea
        currentQuery={currentQuery}
        setCurrentQuery={setCurrentQuery}
        onClick={submitSearch}
      />
      <ListArea groupList={currentHits} />
    </Container>
  );
};

const ListArea: React.FC<{ groupList: Group[] }> = ({ groupList }) => {
  return (
    <section>
      {groupList.map((group) => (
        <GroupListItem key={group.objectID} group={group} />
      ))}
    </section>
  );
};

export const normaliseGroupScore = (value: number) =>
  ((value - 0) * 100) / (362 - 0);

const GroupListItem: React.FC<{ group: Group }> = ({ group }) => {
  const history = useHistory();

  return (
    <Card
      style={{ marginBottom: "20px" }}
      onClick={() => {
        history.push(`/group/${group.objectID}`);
      }}
    >
      <CardContent>
        <Grid container direction="row">
          <Grid item style={{ marginRight: "10px" }}>
            <Avatar
              src={`https://storage.googleapis.com/futurereadinessindex.appspot.com/groups_logos/${group.clean_group}.png`}
              alt={group.group}
              style={{ height: "75px", width: "75px" }}
            />
          </Grid>
          <Grid item xs={true}>
            <Typography variant="h5" gutterBottom align="center">
              {group.group}
            </Typography>

            <ScoreView
              score={group.score}
              scoreNormalised={normaliseGroupScore(group.score)}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
